/**
 * Paging arrows for the featured-products track.
 *
 * The track is a scroll-snap grid, so swipe and trackpad scrolling already work
 * natively. These arrows page by one viewport width and disable themselves at
 * either end.
 */
(() => {
  const SECTION = '[data-pt-featured-viewport]';

  const trackOf = (section) => section.querySelector('[data-pt-featured-track]');

  const syncButtons = (root) => {
    const track = trackOf(root);
    const prev = root.parentElement?.querySelector('[data-pt-featured-prev]');
    const next = root.parentElement?.querySelector('[data-pt-featured-next]');
    if (!track || !prev || !next) return;

    // Sub-pixel widths mean scrollLeft rarely hits the exact maximum.
    const max = track.scrollWidth - track.clientWidth - 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
  };

  const page = (root, direction) => {
    const track = trackOf(root);
    if (!track) return;

    track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
  };

  const init = (root) => {
    if (root.dataset.ptFeaturedReady) return;
    root.dataset.ptFeaturedReady = '1';

    const track = trackOf(root);
    if (!track) return;

    const controls = root.parentElement;
    controls?.querySelector('[data-pt-featured-prev]')?.addEventListener('click', () => page(root, -1));
    controls?.querySelector('[data-pt-featured-next]')?.addEventListener('click', () => page(root, 1));

    let pending = false;
    track.addEventListener(
      'scroll',
      () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {
          pending = false;
          syncButtons(root);
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', () => syncButtons(root));
    syncButtons(root);
  };

  const initAll = () => document.querySelectorAll(SECTION).forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
